import React from "react";
import {SuccessSVG} from "assets";
import {DataType} from "types/models/refractive-type";
import {FIELD_TYPE, FORMAT_TIME} from "types/enums";
import {ColumnsType} from "antd/es/table";
import {
  birthday2Age,
  convertDateStringToDateTimezone_7,
  convertDateStringToDateTimezone_7Dayjs,
} from "helper/common";
import moment from "moment";
import TTTTTypeColumn from "components/common/ColumnColors/KCBTypeColumn/TTTTTypeColumn";
import {DataFormField} from "types/models/input-field-type";
const {INPUT, SELECT, DATE, CHECKBOX} = FIELD_TYPE;
const receivedTableDataSource: DataType[] = [];

const fields: DataFormField[] = [
  {
    type: INPUT,
    label: "Mã phiếu khám",
    name: "maKhamBenh",
  },
  {
    type: INPUT,
    label: "Mã bệnh nhân",
    name: "maBenhNhan",
    expand: false,
  },
  {
    type: INPUT,
    label: "Họ tên",
    name: "hoVaTen",
    expand: false,
  },
  {
    type: DATE,
    label: "Ngày sinh",
    name: "ngaySinh",
    expand: false,
  },
  {
    type: SELECT,
    label: "Trạng thái TT",
    name: "trangThaiThanhToan",
    placeholder: "Chọn",
    options: [
      {value: 0, label: "Chưa thanh toán"},
      {value: 1, label: "Đã thanh toán"},
      {value: 2, label: "Huỷ thanh toán"},
      {value: 3, label: "Đã hoàn phí"},
    ],
    expand: false,
  },
  {
    type: INPUT,
    label: "Số thẻ BHYT",
    name: "soTheBaoHiemYTe",
    expand: true,
  },
  {
    type: SELECT,
    label: "Giới tính",
    name: "gioiTinh",
    options: [
      {value: 0, label: "Nam"},
      {value: 1, label: "Nữ"},
    ],
    placeholder: "Nam/Nữ",
    expand: true,
  },
  {
    type: SELECT,
    label: "Loại KCB",
    name: "loaiKhamChuaBenh",
    placeholder: "Chọn",
    expand: true,
  },
  {
    type: SELECT,
    label: "Trạng thái BH",
    name: "idTrangThaiBaoHiem",
    placeholder: "Chọn",
    expand: true,
  },
  {
    type: SELECT,
    label: "Khu KCB",
    name: "idKhuKhamChuaBenh",
    expand: true,
  },
  {
    type: DATE,
    label: "Từ ngày",
    name: "ngayBatDau",
    expand: true,
    optionsTime: {showTime: false, format: FORMAT_TIME.dayFull},
    disableDate: false,
  },
  {
    type: DATE,
    label: "Đến ngày",
    name: "ngayKetThuc",
    disableDate: false,
    expand: true,
    optionsTime: {showTime: false, format: FORMAT_TIME.dayFull},
  },
];

const columns: any[] = [
  {
    title: "STT",
    key: "stt",
    isResizable: true,
    show: true,
    dataIndex: "stt",
    // render: (text, record, index) => {
    //   const rowNumber = (currentPage - 1) * params.limit + index + 1;
    //   return rowNumber;
    // },
    align: "center",
    fixed: "left",
    width: "40px",
  },
  {
    title: "Mã BN",
    key: "mbn",
    isResizable: true,
    show: true,
    dataIndex: "mbn",
    width: "100px",
    align: "center",
  },
  {
    title: "Mã PK",
    key: "mpk",
    isResizable: true,
    show: true,
    dataIndex: "mpk",
    width: "100px",
    align: "center",
  },
  {
    title: "Họ tên",
    key: "name",
    isResizable: true,
    show: true,
    dataIndex: "name",
  },
  {
    title: "Giới tính",
    key: "gender",
    isResizable: true,
    show: true,
    dataIndex: "gender",
    render: gender => {
      if (gender == "0") {
        return "Nam";
      } else if (gender == "1") {
        return "Nữ";
      }
    },
    width: "80px",
    align: "left",
  },
  {
    title: "Tuổi",
    key: "tuoi",
    isResizable: true,
    show: true,
    dataIndex: "tuoi",
    render: (text, record: {born: Date}) =>
      record.born ? birthday2Age(record.born) : "",
    width: "80px",
    align: "center",
  },
  {
    title: "Ngày sinh",
    key: "born",
    isResizable: true,
    show: true,
    dataIndex: "born",
    render: (text, record) =>
      convertDateStringToDateTimezone_7Dayjs(text, FORMAT_TIME.dayFull),
    width: "100px",
    align: "center",
  },
  {
    title: "TTTT",
    key: "tttt",
    isResizable: true,
    show: true,
    dataIndex: "tttt",
    align: "center",
    render: text => {
      let textTT;
      if (text == 0) {
        textTT = "Chưa thanh toán";
      } else if (text == 1) {
        textTT = "Đã thanh toán";
      } else if (text == 2) {
        textTT = "Huỷ thanh toán";
      } else if (text == 3) {
        textTT = "Đã hoàn phí";
      }
      return <TTTTTypeColumn label={textTT}></TTTTTypeColumn>;
    },
    width: "150px",
  },
  {
    title: "Địa chỉ",
    key: "address",
    isResizable: true,
    show: true,
    dataIndex: "address",
  },
  {
    title: "Loại KCB",
    key: "kcb",
    isResizable: true,
    show: true,
    dataIndex: "kcb",
    // render: kcb => {
    //   if (kcb == 0) return <div>Khám thông thường</div>;
    //   if (kcb == 1) return <div>Cấp cứu</div>;
    //   if (kcb == 2) return <div>Tái khám thông thường</div>;
    //   if (kcb == 3) return <div>Tái khám sau phẫu thuật</div>;
    //   if (kcb == 4) return <div>Hẹn phẫu thuật</div>;
    //   if (kcb == 5) return <div>Khám đo kính</div>;
    //   if (kcb == 6) return <div>Định kỳ</div>;
    //   if (kcb == 7) return <div>Khác</div>;
    // },
  },
  {
    title: "Số thẻ BHYT",
    key: "bhyt",
    isResizable: true,
    show: true,
    dataIndex: "bhyt",
    align: "center",
  },
  {
    title: "TTBH",
    key: "ttbh",
    isResizable: true,
    show: true,
    dataIndex: "ttbh",
    align: "center",
    render: text => {
      let textTT;
      if (text == 0) {
        textTT = "Có";
      } else if (text == 1) {
        textTT = "Không";
      }
      return <TTTTTypeColumn label={textTT}></TTTTTypeColumn>;
    },
    width: "80px",
  },
  {
    title: "Thao tác",
    key: "action",
    isResizable: true,
    show: true,
    dataIndex: "action",
    align: "center",
    width: "150px",
  },
];
export {receivedTableDataSource, fields, columns};
